import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Box, Button, Grid, Typography } from '@mui/material';

import EmployeeCreateDetails from './EmployeeCreateDetails';
import EmployeeCreateEmployment from './EmployeeCreateEmployment';
import EmployeeCreateFromCsv from './EmployeeCreateFromCsv';

import { createNewEmployee, findTentativeEmployee } from '../../../../actions/employeesActions';
import { createNewEmployment, findTentativeEmployment } from '../../../../actions/employmentsActions';
import { resetEmployeesState } from '../../../../slices/employeesSlice';

const styles = {
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0.5rem'
  },
  column: {
    paddingX: '1rem'
  }
}

const EmployeeCreate = () => {
  const [employeeRef, setEmployeeRef] = useState('');
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);

  const [employee, setEmployee] = useState({
    _id: '',
    identityNumber: '',
    identityNumberExpedition: new Date().toISOString().slice(0, 10),
    name: '',
    firstLastName: '',
    secondLastName: '',
    address: '',
    city: '',
    fixedPhoneNumber: '',
    mobilePhoneNumber: '',
    birthdate: new Date().toISOString().slice(0, 10),
    birthplace: '',
    gender: '',
    citizenship: '',
    public: true,
  });

  const [employment, setEmployment] = useState({
    _id: '',
    admissionDate: new Date().toISOString().slice(0, 10),
    departureDate: new Date().toISOString().slice(0, 10),
    jobArea: '',
    firstCharge: '',
    lastCharge: '',
    period: 1,
    supervisorName: '',
    supervisorPhone: '',
    supervisorEmail: '',
    departureReason: '',
    current: false,
  });

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const profile = useSelector(state => state.auth.profile);
  const tEmployee = useSelector(state => state.employees.tentative);
  const tEmployment = useSelector(state => state.employments.tentative);

  useEffect(() => {
    return () => {
      dispatch(resetEmployeesState());
    }
  }, []);

  useEffect(() => {
    if(employee.identityNumber.length > 9) {
      dispatch(findTentativeEmployee({ identityNumber: employee.identityNumber }));
    }
  }, [employee.identityNumber]);

  useEffect(() => {
    setEmployeeRef(tEmployee._id);
    setEmployee(prev => ({
      ...prev,
      ...tEmployee,
      identityNumberExpedition: new Date(tEmployee?.identityNumberExpedition ?? new Date()).toISOString().slice(0, 10),
      birthdate: new Date(tEmployee?.birthdate ?? new Date()).toISOString().slice(0, 10),
    }));
  }, [tEmployee]);

  useEffect(() => {
    setEmployment(prev => ({
      ...prev,
      ...tEmployment,
      companyRef: tEmployment.companyRef?._id ?? prev.companyRef,
      employeeRef: tEmployee.employeeRef?._id ?? employeeRef,
      admissionDate: new Date(tEmployee?.tEmployment ?? new Date()).toISOString().slice(0, 10),
      departureDate: new Date(tEmployee?.tEmployment ?? new Date()).toISOString().slice(0, 10),
    }));
  }, [tEmployment]);

  useEffect(() => {
    if(employeeRef?.length > 0 && profile.companyRef?._id?.length > 0) {
      dispatch(findTentativeEmployment({ query: { employee: employeeRef, company: profile.companyRef?._id } }));
    }
  }, [employeeRef, profile.companyRef]);

  const handleChangeEmployee = e => setEmployee({ ...employee, [e.target.name]: e.target.value });
  const handleChangeEmployment = e => setEmployment({ ...employment, [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });

  const handleOpenBatch = () => setOpen(true);
  const handleCloseBatch = () => setOpen(false);

  const handleEmployeeCreated = id => {
    setShow(true);
    setEmployeeRef(id);
  }

  const handleSaveEmployee = e => {
    e.preventDefault();
    dispatch(createNewEmployee({ employee, callback: handleEmployeeCreated }));
  }

  const handleSaveEmpoyment = e => {
    e.preventDefault();
    dispatch(createNewEmployment({
      employment: { ...employment, departureDate: employment.current ? null : employment.departureDate, employeeRef },
      callback: () => navigate('/dashboard/empleados/' + employeeRef)
    }));
  }

  return (
    <>
      <Helmet>
        <title>Cristopher | Empleado nuevo</title>
      </Helmet>
      <Box sx={styles.title}>
        <Typography variant="h5" fontWeight="bold">Nuevo empleado</Typography>
        <Button onClick={handleOpenBatch}>Importar Archivos</Button>
      </Box>
      <Grid container>
        <Grid item xs={12} sx={styles.column}>
          <EmployeeCreateDetails {...employee} onChange={handleChangeEmployee} onSubmit={handleSaveEmployee} />
        </Grid>
        <Grid item xs={12} sx={styles.column}>
          <EmployeeCreateEmployment {...employment} onChange={handleChangeEmployment} onSubmit={handleSaveEmpoyment} show={show} />
        </Grid>
      </Grid>
      <EmployeeCreateFromCsv open={open} onClose={handleCloseBatch} />
    </>
  );
}

export default EmployeeCreate;
